
import React from 'react';
import { VideoFeatures } from '@/store/videoFeatures';
import { ThumbnailOverlay } from './ThumbnailOverlay';

interface ThumbnailOverlaysProps {
  features: VideoFeatures;
  showInitialThumbnail: boolean;
  showPauseThumbnail: boolean;
  showEndThumbnail: boolean;
  onThumbnailClick: () => void;
}

export const ThumbnailOverlays: React.FC<ThumbnailOverlaysProps> = ({
  features,
  showInitialThumbnail,
  showPauseThumbnail,
  showEndThumbnail,
  onThumbnailClick
}) => {
  return (
    <>
      {/* Initial Thumbnail Overlay */}
      {showInitialThumbnail && features.initialThumbnail && (
        <ThumbnailOverlay 
          thumbnail={features.initialThumbnail} 
          type="initial"
          onThumbnailClick={onThumbnailClick}
        />
      )}
      
      {/* Pause Thumbnail Overlay */}
      {showPauseThumbnail && features.pauseThumbnail && (
        <ThumbnailOverlay 
          thumbnail={features.pauseThumbnail} 
          type="pause"
          onThumbnailClick={onThumbnailClick}
        />
      )}
      
      {/* End Thumbnail Overlay */}
      {showEndThumbnail && features.endThumbnail && (
        <ThumbnailOverlay 
          thumbnail={features.endThumbnail} 
          type="end"
          onThumbnailClick={onThumbnailClick}
        />
      )}
    </>
  );
};
